import React from 'react';
import './index.scss';
import { useEffect, useState } from 'react';
import { onShow, onHide } from '@intercom/messenger-js-sdk';

const AiChatAdvert = () => {

    const [aiChatAdvert, setAiChatAdvert] = useState(false); // 用于存储是否显示广告
    const [mbHide, setMbHide] = useState(false); // 用于存储是否隐藏广告
    const [cssDistance, setCssDistance] = useState({
        bottom: 0,
        right: 0
    }); // 用于存储计算后的CSS距离
    const [frameWidth, setFrameWidth] = useState(0); // 用于存储intercom-messenger-frame宽度

    useEffect(() => {
        // 等待 Intercom 加载
        function waitForIntercom(cb) {
            if (window.Intercom && window.Intercom.booted) {
                cb();
            } else {
                setTimeout(() => waitForIntercom(cb), 200);
            }
        }

        // 完成加载后执行
        waitForIntercom(() => {
            // 打开
            onShow(() => {
                setAiChatAdvert(true);
            });

            // 关闭
            onHide(() => {
                setAiChatAdvert(false);
            });
        })

    }, []);

    // 监听intercom-messenger-frame宽度
    useEffect(() => {
        let resizeObserver = null;
        let rafId = null;

        // 监听 intercom iframe 创建
        const domObserver = new MutationObserver(() => {
            const frame = document.querySelector('.intercom-messenger-frame');
            if (frame) {
                // 停止继续监听 DOM
                domObserver.disconnect();

                // 监听宽度变化
                resizeObserver = new ResizeObserver(entries => {
                    // 将 setState 延迟到下一帧执行，避免在 ResizeObserver 回调中
                    // 同步触发重排，从而消除 "ResizeObserver loop ..." 警告
                    if (rafId) cancelAnimationFrame(rafId);
                    rafId = requestAnimationFrame(() => {
                        for (let entry of entries) {
                            const width = entry.contentRect.width;
                            // 仅在宽度真正变化时更新，减少多余渲染
                            setFrameWidth(prev => (prev !== width ? width : prev));
                        }
                    });
                });

                resizeObserver.observe(frame);
            }
        });

        domObserver.observe(document.body, {
            childList: true,
            subtree: true
        });

        // 组件卸载时清理
        return () => {
            domObserver.disconnect();
            if (resizeObserver) resizeObserver.disconnect();
            if (rafId) cancelAnimationFrame(rafId);
        };
    }, []);

    // 监听类名intercom-launcher 点击
    useEffect(() => {
        let rafId = null;

        // 封装一个函数：在当前 DOM 中查找并绑定事件
        const bindLauncherEvent = () => {
            // 绑定点击事件
            const launcher = document.querySelector('.intercom-launcher');

            // 获取离底部和右边的距离
            if (launcher) {
                const bottomDistance = window.getComputedStyle(launcher).bottom;
                const rightDistance = window.getComputedStyle(launcher).right;

                if (parseFloat(bottomDistance) > 0) {
                    const nextBottom = parseFloat(bottomDistance);
                    const nextRight = parseFloat(rightDistance);
                    // 仅在距离真正变化时更新，减少多余渲染
                    setCssDistance(prev =>
                        prev.bottom !== nextBottom || prev.right !== nextRight
                            ? { bottom: nextBottom, right: nextRight }
                            : prev
                    );
                }
            }
        };

        // 初始化绑定一次
        bindLauncherEvent();

        // 创建 MutationObserver 监听 DOM 更新，使用 rAF 节流，避免频繁回调
        const observer = new MutationObserver(() => {
            if (rafId) return;
            rafId = requestAnimationFrame(() => {
                rafId = null;
                bindLauncherEvent();
            });
        });

        observer.observe(document.body, {
            childList: true,
            subtree: true,
        });

        // 组件卸载时清理
        return () => {
            observer.disconnect();
            if (rafId) cancelAnimationFrame(rafId);
        };
    }, []);

    // 监听屏幕宽度
    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth <= 450) {
                setMbHide(true);
            } else {
                setMbHide(false);
            }
        };
        // 初始化执行一次
        handleResize();
        // 监听窗口变化
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    return (
        <div
            className={`ai-chat-advert ${aiChatAdvert && !mbHide ? 'with-transition' : ''}`}
            style={{
                opacity: aiChatAdvert ? 1 : 0,
                zIndex: aiChatAdvert ? 2147483647 : -9999,
                display: mbHide || !Boolean(cssDistance?.bottom || cssDistance?.right) ? 'none' : 'flex',
                bottom: `${cssDistance?.bottom + 52}px`,
                right: `${cssDistance?.right}px`,
                width: frameWidth
            }}
            onClick={() => {
                window.open("https://share.channelwill.com/app/40690c066d030a4pd5", "_blank");
            }}
        >
            <div className='ai-chat-advert-content'>
                <p>Get Free AI Chatbot</p>
            </div>
        </div>
    );
};

export default AiChatAdvert;